import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-background text-white pt-12 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          <div className="mb-8 md:mb-0">
            <h3 className="text-xl font-bold mb-4">CALLGIRLNOIDA</h3>
            <p className="text-gray-300">Your Pleasure is Our Priority</p>
          </div>
          <div className="mb-8 md:mb-0">
            <h3 className="text-xl font-bold mb-4">Our Locations</h3>
            <ul className="space-y-2">
              <li><a href="#delhi" className="hover:text-primary">DELHI</a></li>
              <li><a href="#bangalore" className="hover:text-primary">BANGALORE</a></li>
              <li><a href="#hyderabad" className="hover:text-primary">HYDERABAD</a></li>
              <li><a href="#gurgaon" className="hover:text-primary">GURGAON</a></li>
              <li><a href="#mumbai" className="hover:text-primary">MUMBAI</a></li>
              <li><a href="#jaipur" className="hover:text-primary">JAIPUR</a></li>
              <li><a href="#chennai" className="hover:text-primary">CHENNAI</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <p>Phone: +917838380756</p>
            <p>Address: NOIDA Gaur City</p>
            <p>Email: gupta01433@gmail.com</p>
          </div>
        </div>
        <div className="text-center text-gray-400 mt-8 pt-8 border-t border-gray-700">
          <p>&copy; {new Date().getFullYear()} CALLGIRLNOIDA. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
